import { useEffect, useState } from "react";

const MOBILE_MEDIA_QUERY = "(max-width: 639px)"; // < 640px (Tailwind `sm`)

/**
 * True when the viewport is below the 640px (Tailwind `sm`) breakpoint.
 *
 * Pass the dashboard iframe window (`targetWindow`) so the query tracks the real device width —
 * the viewer renders inside a full-window iframe, so its `matchMedia` matches the device. Falls
 * back to the top-level window if none is provided.
 */
export function useIsMobile(targetWindow?: Window | null): boolean {
  const view = targetWindow ?? (typeof window !== "undefined" ? window : null);

  const [isMobile, setIsMobile] = useState<boolean>(
    () => view?.matchMedia(MOBILE_MEDIA_QUERY).matches ?? false
  );

  useEffect(() => {
    if (!view) {
      return;
    }
    const mql = view.matchMedia(MOBILE_MEDIA_QUERY);
    const handler = () => setIsMobile(mql.matches);
    handler();
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [view]);

  return isMobile;
}
